import { Add } from '@mui/icons-material'

import { ListHeaderActions, ListHeaderPrimaryActionButton } from '@/components/List'

import { ReadOnlyTooltip } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { useIsLoading } from '@/atoms'
import { Tooltip } from '@/components/primitives/Tooltip'

import { useTexts } from '../../../../hooks/useTexts'
import { useActions } from './hooks/useActions'

export function Actions() {
  const { editing, onCreate } = useActions()
  const isLoading = useIsLoading()
  const texts = useTexts()

  return (
    <ListHeaderActions>
      <ReadOnlyTooltip
        placement="bottom"
        canEdit={!isLoading}
        title={texts.disabledForLoadingTooltip}
        render={preventEditing => (
          <Tooltip title={texts.addGeofence} placement="bottom">
            <ListHeaderPrimaryActionButton
              disabled={preventEditing || editing}
              onClick={onCreate}
              trackId="geofences__create-new-button"
            >
              <Add />
            </ListHeaderPrimaryActionButton>
          </Tooltip>
        )}
      />
    </ListHeaderActions>
  )
}
